import React from 'react';
import { CardStat, CardStatLabel, CardStatRow } from '../../../components/card-stat';

interface EmptyMetricWithBarProps extends React.HTMLAttributes<HTMLDivElement> {
  valueType: 'currency' | 'percentage';
  currency?: string;
  showNonAttributedData?: boolean;
}

export const EmptyMetricWithBar = React.forwardRef<HTMLDivElement, EmptyMetricWithBarProps>(
  ({ valueType, showNonAttributedData = false }, ref) => (
    <div ref={ref} className="h-full flex flex-row">
      <div className={`flex flex-col justify-center ${showNonAttributedData ? 'flex-1' : 'flex-1 w-full'}`}>
        <div className="space-y-4">
          <div className="space-y-2">
            <CardStatRow>
              <CardStat className="text-xl leading-none text-[#cbd1d7]">
                {valueType === 'currency' ? '$-' : '-.0%'}
              </CardStat>
              <div className="flex items-center gap-1 text-xs text-[#cbd1d7]">
                <span>-%</span>
              </div>
            </CardStatRow>
            <CardStatLabel className="text-[#cbd1d7]">Attributed to Aspire</CardStatLabel>
          </div>
          {showNonAttributedData && (
            <div className="space-y-2">
              <CardStatRow>
                <CardStat className="text-xl leading-none text-[#cbd1d7]">
                  {valueType === 'currency' ? '$-' : '-.0%'}
                </CardStat>
                <div className="flex items-center gap-1 text-xs text-[#cbd1d7]">
                  <span>-%</span>
                </div>
              </CardStatRow>
              <CardStatLabel className="text-[#cbd1d7]">Not Attributed to Aspire</CardStatLabel>
            </div>
          )}
        </div>
      </div>
      {showNonAttributedData && (
        <div className="flex-1 h-full flex flex-col justify-end min-w-[120px]">
          {/* Bar chart placeholder */}
          <div className="flex items-end justify-center h-16 w-16 mx-auto mb-4 gap-2">
            <div className="w-4 h-8 bg-[#cbd1d7]" />
            <div className="w-4 h-4 bg-[#e5e8eb]" />
          </div>
        </div>
      )}
    </div>
  ),
);

EmptyMetricWithBar.displayName = 'EmptyMetricWithBar';
